<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <el-form :label-position="labelPosition" :rules="rules" label-width="150px" :model="detailList">
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="detailList.realname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idcard">
            <el-input v-model="detailList.idcard" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="detailList.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="学员类型" prop="category" class="all_width">
            <el-select v-model="detailList.category" filterable placeholder="请选择学员类型" >
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in studentTypeArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="民族" prop="nation" class="all_width">
            <el-select v-model="detailList.nation" placeholder="请选择民族" filterable >
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in nationArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文化程度" prop="degree" class="all_width">
            <el-select v-model="detailList.degree" filterable placeholder="请选择文化程度" >
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in degreeArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="specialty">
            <el-input v-model="detailList.specialty" placeholder="请输入专业"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'addStudent',
  components:{
  },
  data(){
    return {
      rules:{
        realname :[{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone :[{required: true, message: '请输入手机号', trigger: 'blur'}],
        idcard :[{required: true, message: '请输入身份证号', trigger: 'blur'}],
        category :[{required: true, message: '请选择学员类型', trigger: 'change'}],
        nation :[{required: true, message: '请选择民族', trigger: 'change'}],
        degree :[{required: true, message: '请选择文化程度', trigger: 'change'}],
        specialty :[{required: true, message: '请输入专业', trigger: 'blur'}],

      },
      labelPosition: 'right',
      citys:'',
      areas:'',
      degreeArr:[],
      period_id:'',
      detailList:{},
      nationArr:[]
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    this.period_id = this.$route.query.period
    this.province = JSON.parse(this.$store.state.province) || JSON.parse(localStorage.getItem('province'))
    this.studentTypeArr = JSON.parse(this.$store.state.student_type) || JSON.parse(localStorage.getItem('student_type'))
    
    let inforParams = {
      student_id:this.id
    }
    this.getInfor(inforParams)
    this.obtainDegree()
  },
  mounted(){

  },
  methods:{
    getInfor(params){
      this.$api.user.detailStudent(params)
      .then(res=>{
        if(res.code === 0){
          this.detailList = res.result
          if(this.detailList.category === 0){
            this.detailList.category = '请选择'
          }
        }
      }) 
    },
    obtainDegree(){
      this.$api.user.getConfig()
      .then(res=>{
        if(res.code === 0){
          this.degreeArr = res.result.degree
          this.nationArr = res.result.nation
        }
      }) 
    },
    onSubmit(){
    let params = {
      student_id: this.id, 
      realname: this.detailList.realname,
      phone:this.detailList.phone,
      idcard:this.detailList.idcard,
      category:this.detailList.category,
      nation:this.detailList.nation,
      degree:this.detailList.degree,
      specialty:this.detailList.specialty
    }
    if(!this.detailList.realname){
      this.$message.error('请输入姓名');
    }else if(!this.detailList.phone){
      this.$message.error('请输入手机号');
    }else if(!this.detailList.idcard){
      this.$message.error('请输入身份证号');
    }else if(!this.detailList.category){
      this.$message.error('请选择学生类别');
    }else if(!this.detailList.nation){
      this.$message.error('请选择民族');
    }else if(!this.detailList.degree){
      this.$message.error('请选择文化程度');
    }else if(!this.detailList.specialty){
      this.$message.error('请输入专业');
    }else{
      this.$api.user.editStudent(params)
        .then(res=>{
          if(res.code === 0){
            this.$message.success('编辑成功！')
            this.$router.replace({
              path:'/period/periodStudent/' + this.period_id,
            })
          }
        }) 
      }
    },
  },
}
</script>>
<style lang="scss" scoped>
  @import '../../../assets/scss/content.scss';
  @import '../../../assets/scss/editRotation.scss';
  @import '../../../assets/scss/addOrganization.scss';
  @import '../../../assets/scss/period.scss';
</style>
